import { render, staticRenderFns } from "./Adspot.vue?vue&type=template&id=0cf0c54c&scoped=true&"
import script from "./Adspot.vue?vue&type=script&lang=js&"
export * from "./Adspot.vue?vue&type=script&lang=js&"
import style0 from "./Adspot.vue?vue&type=style&index=0&id=0cf0c54c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf0c54c",
  null
  
)

component.options.__file = "Adspot.vue"
export default component.exports